import { render } from "./ViewsReturn.vue?vue&type=template&id=4d160c92"
import script from "./ViewsReturn.vue?vue&type=script&lang=js"
export * from "./ViewsReturn.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__